import * as ActionTypes from './actionTypes'

export const setHowmanyPaginationButtonsToClick=(newData)=>{
    return {
        type : ActionTypes.SET_HOW_MANY_PAGINATION_BUTTONS_TO_CLICK,
        payload : newData
    }
}
